import { Formik, Form } from "formik";
import * as Yup from "yup";

// --------------- component
import { InputField, SelectField } from "../../../components";

// --------------- style
import "./style.css";
import { api } from "../../../api/url";
import axios from "axios";
import { toast } from "react-hot-toast";
import { FiEdit2 } from "react-icons/fi";
const genders = [
  { name: "آقا", id: 1 },
  { name: "خانم", id: 2 },
];

const ProfileSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("فیلد نام الزامی می‌باشد")
    .matches(/^\s*\S[\s\S]*$/, "فیلد نمی‌تواند خالی باشد"),
  genderId: Yup.string().required("فیلد جنسیت الزامی می‌باشد"),
  lastName: Yup.string()
    .required("فیلد نام‌خانوادگی الزامی می‌باشد")
    .matches(/^(?!\s+$)/, "فیلد نمی‌تواند خالی باشد"),
  nationalCode: Yup.string()
    .required("فیلد کدملی الزامی می‌باشد")
    .matches(/^(?!\s+$)/, "فیلد نمی‌تواند خالی باشد")
    .matches(/^\d+$/, "فرمت کدملی صحیح نمی‌باشد"),

});

const GetPhoneNumber = (props) => {


  // ------------------- get otp
  const GetOtp = async (value, setSubmitting) => {
    props.setUserInfo({ ...props.userInfo, ...value });
    await axios({
      url: api + "appointment/login/getotp/" + props.userInfo.mobileNo,
      method: "get",
    })
      .then((res) => {
        props.setStep(2);
      })
      .catch((err) => {
        setSubmitting(false);
      });
  };


  return (
    <div className="modal-phonenumber-container">
      <Formik
        initialValues={{
          firstName: props.userInfo.firstName,
          lastName: props.userInfo.lastName,
          nationalCode: props.userInfo.nationalCode,
          genderId: props.userInfo.genderId,
        }}
        validationSchema={ProfileSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          GetOtp(values, setSubmitting);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <h5 className="visit-userinfo-modal-title">اطلاعات شخصی</h5>
            <p className="visit-userinfo-modal-description">
              لطفا اطلاعات خودرا وارد کنید.
            </p>
            <div className="profile-field-section visit-userinfo-field">
              <InputField autoFocus={true} name="firstName" title="نام" />
              <InputField name="lastName" title="نام‌خانوادگی" />
            </div>

            <div className="profile-field-section visit-userinfo-field">
              <InputField inputstyle={{ textAlign: 'right' }} type='tel' maxlength="10" name="nationalCode" title="کدملی" />
              <SelectField
                selectStyle={{ width: "100%" }}
                options={genders}
                name="genderId"
                title="جنسیت"
              />
            </div>

            <button
              className="submit-form-btn visit-userinfo-btn"
              type="submit"
              disabled={isSubmitting}
            >
              تایید
            </button>
            <a className="edit-phonenumber back-form-btn" onClick={() => props.setStep(0)}>
              <FiEdit2 />
              اصلاح شماره موبایل
            </a>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default GetPhoneNumber;
